const wordmark = (
  <span style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-.02em', color: 'var(--text-strong)' }}>
    Get<span style={{ color: 'var(--brand-green)' }}>Pay</span>93
  </span>
);

export function PublicNav() {
  const link = { fontSize: 15, fontWeight: 600, color: 'var(--text-muted)', textDecoration: 'none' } as const;
  return (
    <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 48px', maxWidth: 1160, margin: '0 auto', boxSizing: 'border-box' }}>
      <a href="/" style={{ textDecoration: 'none' }}>{wordmark}</a>
      <nav style={{ display: 'flex', gap: 28, alignItems: 'center' }}>
        <a href="/#features" style={link}>Producto</a>
        <a href="/precios" style={link}>Precios</a>
        <a href="/login" style={link}>Iniciar sesión</a>
        <a href="/registro" style={{ display: 'inline-flex', alignItems: 'center', height: 48, padding: '0 20px', background: 'var(--brand-green)', color: '#FFFFFF', borderRadius: 12, fontSize: 16, fontWeight: 800, textDecoration: 'none' }}>Crear cuenta gratis</a>
      </nav>
    </header>
  );
}

export { wordmark };
